import Image from 'next/image';

import { Box, Flex, Heading, List, ListItem } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export type TimelineSectionProps = {
  title: string;
  events: Array<{ _id: string; title: string; text: string }>;
};
export function TimelineSection({ title, events = [] }: TimelineSectionProps) {
  return (
    <Box
      as='section'
      backgroundColor='white'
      overflow='hidden'
      position='relative'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <Box
        bottom='0px'
        height='416px'
        left='50%'
        position='absolute'
        right='0px'
        top='0px'
        transform='translateX(-50%)'
        width='2000px'
        display={{
          base: 'none',
          md: 'block',
        }}
      >
        <Image
          alt=''
          sizes='2000px'
          src='/images/backgrounds/blue-lines-wide.png'
          style={{
            objectFit: 'cover',
            objectPosition: 'center bottom',
            opacity: 0.3,
            pointerEvents: 'none',
          }}
          fill
        />
      </Box>
      <ContentContainer position='relative'>
        <Heading as='h2' marginBottom='48px' size='marketing-4xl' textAlign='center'>
          {title}
        </Heading>
        <List as='ol' display='flex' flexDir='column' gap='16px'>
          {events.map((event) => (
            <ListItem key={event._id} backgroundColor='accent.sky.100' display='flex' padding='24px 32px'>
              <Flex
                as='article'
                width='100%'
                alignItems={{
                  md: 'center',
                }}
                flexDir={{
                  base: 'column',
                  md: 'row',
                }}
                gap={{
                  base: '48px',
                  md: '96px',
                }}
              >
                <Heading
                  as='p'
                  color='blue.500'
                  fontWeight='500'
                  size='marketing-lg'
                  flex={{
                    md: '0 0 282px',
                  }}
                >
                  {event.title}
                </Heading>
                <Heading
                  as='p'
                  flex='1'
                  position='relative'
                  size='marketing-lg'
                  sx={{
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      height: 'auto',
                      border: '0.5px solid',
                      borderColor: 'accent.sky.500',
                      left: {
                        base: 0,
                        md: '-48px',
                      },
                      right: {
                        base: 0,
                        md: 'unset',
                      },
                      top: {
                        base: '-24px',
                        md: 0,
                      },
                      bottom: {
                        md: 0,
                      },
                    },
                  }}
                >
                  {event.text}
                </Heading>
              </Flex>
            </ListItem>
          ))}
        </List>
      </ContentContainer>
    </Box>
  );
}
